// JOBS
export const API_OUR_WORK = 'work';
export const API_WHAT_WE_DO = 'what-we-do';
export const API_OUR_TEAM = 'team';
export const API_OFFICES = 'office';
export const API_HOW_WE_DO = 'how-do-it';
export const API_CONFIG = 'config';
export const API_BLOG = 'blog';
export const API_PODCAST = 'podcast';
export const API_PARTNER = 'our-partner';
export const API_INFLUENCER = 'influencer';
export const API_CLIENT = 'our-client';